/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2021-11-16 10:03:41
 * @LastEditors: zhanghang
 * @LastEditTime: 2021-12-23 14:08:43
 */
import ncFileUploadMetaData from "./ncFileUploadMetaData";

dsf.metadata.add("nc-file-upload-meta-data", ncFileUploadMetaData);
